import { get, memoize, isEmpty } from 'lodash';

/**
 * A return a list of browsers that Bonjoros web recorder currently supports
 */
export const browserSupportList = memoize(() => ({
  chrome: true,
  firefox: true,
  opera: true,
  safari: true,
  edge: false,
}));

// eslint-disable-next-line
type Maybe = any;

declare global {
  const InstallTrigger: Maybe;

  interface Document {
    documentMode: Maybe;
  }
}

export const detectBrowser = memoize(() => {
  // Internet Explorer 6-11
  const isIE = /*@cc_on!@*/ false || !!document.documentMode;

  if (isIE) {
    return 'ie';
  }

  // Edge 20+
  const isEdge = !isIE && !!window.StyleMedia;

  if (isEdge) {
    return 'edge';
  }
  // Chrome 1+
  const isChrome = !!window.chrome;

  if (isChrome) {
    return 'chrome';
  }

  // Opera 8.0+ (UA detection to detect Blink/v8-powered Opera)
  const isOpera = !!window.opera || navigator.userAgent.includes(' OPR/');

  if (isOpera) {
    return 'opera';
  }

  // Firefox 1.0+
  const isFirefox = typeof InstallTrigger !== 'undefined';

  if (isFirefox) {
    return 'firefox';
  }

  // Safari 3.0+
  const isSafari =
    /constructor/i.test(window.HTMLElement.toString()) ||
    // eslint-disable-next-line
    (function (p: any) {
      return p.toString() === '[object SafariRemoteNotification]';
    })(!window['safari'] || window['safari'].pushNotification) ||
    navigator.userAgent.includes('Safari');

  if (isSafari) {
    return 'safari';
  }

  // Blink engine detection
  const isBlink = (isChrome || isOpera) && !!window.CSS;

  if (isBlink) {
    return 'blink';
  }
});

export function supportsMediaRecorder(): boolean {
  return (
    typeof window.MediaRecorder === 'function' &&
    !isEmpty(getSupportedMimeTypes())
  );
}

export function supportsRecording(mimeType: string): boolean {
  return window.MediaRecorder?.isTypeSupported?.(mimeType) ?? false;
}

export function getSupportedMimeTypes(
  mimeTypes: string[] = ['video/webm', 'video/mp4']
): string[] {
  return mimeTypes.filter(supportsRecording);
}

export function browserSupported(): boolean {
  const browser = detectBrowser();

  if (browser == null) {
    return false;
  }

  return get(browserSupportList(), browser, false);
}
